/* 
 * ProblemModel.js
 * 
 * @author Olivier van der Pool for Ranj
 */

export default class ProblemModel {
    constructor() {
        this._problems = [];
        this._possibleArguments = [];
    }

    addProblem(problem) {
        this._problems.push(problem);
    }

    getProblems() {
        return this._problems;
    }

    getProblemByID(id) {
        for (let i = 0; i < this._problems.length; i++) {
            if (this._problems[i].getID() === id) {
                return this._problems[i];
            }
        }
        return null;
    }

    getPossibleArguments() {
        return this._possibleArguments;
    }

    addPossibleArgument(argument) {
        this._possibleArguments.push(argument);
    }

    getPossibleArgumentByID(id) {
        for (let i = 0; i < this._possibleArguments.length; i++) {
            if (this._possibleArguments[i].getID() === id) {
                return this._possibleArguments[i];
            }
        }
        return null;
    }

    isArgumentCorrect(problemID, solutionID, argumentID) {
        const problem = this.getProblemByID(problemID);
        if (problem === null) return false;
        const correct = problem.checkArgument(solutionID, argumentID);
        return correct;
    }
}